export default __webpack_public_path__ + "static/media/foto7.ad86ed4f.jpg";